import React, { useState } from "react";
import DepartmentProductionDetailModal from "./DepartmentProductionDetailModal";
import ItemService from "../../../../../services/commonService";
import { toastFunc } from "../../../../common/util";

const formatNumber = (value) => {
  if (value === null || value === undefined || value === "") return "0";

  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
  }).format(Number(value) || 0);
};

const DepartmentProductionSummary = ({ departments = [], filters }) => {
  const [activeDetail, setActiveDetail] = useState(null);
  const [downloading, setDownloading] = useState(false);

  const downloadExcel = async () => {
    setDownloading(true);
    try {
      await ItemService.downloadReport({
        url: "dashboard/production/download",
        filter: filters,
      });
      toastFunc("success", "Daily production report downloaded.", 2500);
    } catch (error) {
      toastFunc(
        "error",
        error.message || "Unable to download daily production report.",
        4000,
      );
    } finally {
      setDownloading(false);
    }
  };

  const detailButton = (item, detailType, value, tone = "default") => (
    <button
      type="button"
      className={`production-table__detail-link is-${tone}`}
      onClick={() => setActiveDetail({ department: item, detailType })}
      title={`View ${detailType.toLowerCase()} details for ${item.deptName}`}
      aria-label={`View ${formatNumber(value)} ${detailType.toLowerCase()} for ${item.deptName}`}
    >
      <span>{formatNumber(value)}</span>
      <i className="bi bi-box-arrow-up-right" aria-hidden="true" />
    </button>
  );

  return (
    <>
      <div className="production-dashboard-card table-card">
        <div className="card-title-row">
          <div>
            <h3>Department Production Summary</h3>
            <p>Click Reject, Rework, Jobcards, Machines, or Users to view details.</p>
          </div>
          <button
            type="button"
            className="production-summary-download"
            onClick={downloadExcel}
            disabled={downloading}
          >
            <i
              className={`bi ${
                downloading ? "bi-hourglass-split" : "bi-file-earmark-excel"
              }`}
              aria-hidden="true"
            />
            {downloading ? "Preparing..." : "Download Excel"}
          </button>
        </div>

        <div className="production-table-wrapper">
          <table className="production-table">
            <thead>
              <tr>
                <th>Code</th>
                <th>Department</th>
                <th>Total Qty</th>
                <th>OK Qty</th>
                <th>Reject</th>
                <th>Rework</th>
                <th>OK %</th>
                <th>Reject %</th>
                <th>Jobcards</th>
                <th>Machines</th>
                <th>Users</th>
              </tr>
            </thead>

            <tbody>
              {departments.map((item) => (
                <tr key={item.deptCode || item.deptName}>
                  <td>{item.deptCode}</td>
                  <td><strong>{item.deptName}</strong></td>
                  <td>{formatNumber(item.totalQty)}</td>
                  <td className="success-text">{formatNumber(item.okQty)}</td>
                  <td>{detailButton(item, "REJECT", item.rejectQty, "reject")}</td>
                  <td>{detailButton(item, "REWORK", item.reworkQty, "rework")}</td>
                  <td>{item.okPercentage}%</td>
                  <td>{item.rejectionPercentage}%</td>
                  <td>{detailButton(item, "JOBCARDS", item.jobcardCount)}</td>
                  <td>{detailButton(item, "MACHINES", item.machineCount)}</td>
                  <td>{detailButton(item, "USERS", item.createdUserCount)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {activeDetail && (
        <DepartmentProductionDetailModal
          department={activeDetail.department}
          detailType={activeDetail.detailType}
          filters={filters}
          onClose={() => setActiveDetail(null)}
        />
      )}
    </>
  );
};

export default DepartmentProductionSummary;
